import React, { useState } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';

// Re-consent "updated Terms" gate for the web — mirrors the app ConsentGate.
// Shows a blocking modal for authenticated users the server flags as needing a
// current-version ToS/Privacy signature (server is env-gated OFF by default, so
// this is inert until enabled).
//
// FAIL-SAFE: renders nothing on gate-off / no-auth / any error / needsConsent=false,
// and closes even if the accept write fails (never traps the user).

const CONSENT_STATUS = gql`
  query consentStatus {
    consentStatus { status needsConsent currentVersion }
  }
`;
const ACCEPT_CONSENT = gql`
  mutation acceptConsent {
    acceptConsent { status needsConsent }
  }
`;

const overlay = {
  position: 'fixed', inset: 0, zIndex: 100000,
  background: 'rgba(0,0,0,0.45)', display: 'flex',
  alignItems: 'center', justifyContent: 'center', padding: 16,
};
const card = {
  background: '#fff', borderRadius: 16, maxWidth: 440, width: '100%',
  padding: '26px 24px', boxShadow: '0 12px 48px rgba(0,0,0,0.25)',
};

const ConsentGate = () => {
  const [agreed, setAgreed] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const { data } = useQuery(CONSENT_STATUS, { ssr: false, fetchPolicy: 'network-only' });
  const [accept, { loading: saving }] = useMutation(ACCEPT_CONSENT);

  const needs = data && data.consentStatus && data.consentStatus.needsConsent === true;
  if (!needs || dismissed) return null;

  const onAccept = async () => {
    try {
      await accept();
    } catch (e) {
      /* fail-open: close anyway, server re-checks next load */
    }
    setDismissed(true);
  };

  return (
    <div style={overlay} role="dialog" aria-modal="true" aria-label="Updated Terms">
      <div style={card}>
        <div style={{ fontSize: 19, fontWeight: 800, marginBottom: 8 }}>We’ve updated our Terms</div>
        <div style={{ fontSize: 13.5, lineHeight: 1.45, color: '#606060', marginBottom: 18 }}>
          Please review and accept our updated Terms of Service and Privacy Policy to keep using BestHand.
        </div>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, lineHeight: 1.4, cursor: 'pointer', marginBottom: 20 }}>
          <input type="checkbox" checked={agreed} disabled={saving}
            onChange={(e) => setAgreed(e.target.checked)} style={{ marginTop: 2, flex: '0 0 auto' }} />
          <span>
            I agree to BestHand’s{' '}
            <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>{' '}and{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </span>
        </label>
        <button type="button" onClick={onAccept} disabled={!agreed || saving}
          style={{
            width: '100%', padding: '13px 16px', borderRadius: 12, border: 'none',
            background: (!agreed || saving) ? '#E7B9BC' : '#D32F2F', color: '#fff',
            fontSize: 15, fontWeight: 700, cursor: (!agreed || saving) ? 'default' : 'pointer',
          }}>
          {saving ? 'Saving…' : 'Accept & continue'}
        </button>
      </div>
    </div>
  );
};

export default ConsentGate;
